/**
 * Pure helpers for handling session-break "chunks" during drag-and-drop.
 * Shared between useDragManager (day/week) and useMonthViewDragManager (month).
 */

export const getSessionBreakChunk = (items, startIndex) => {
  const startItem = items[startIndex];
  if (!startItem || startItem.type !== 'session_break') return [];

  const result = [startItem];
  for (let i = startIndex + 1; i < items.length; i += 1) {
    if (items[i].type === 'session_break') break;
    result.push(items[i]);
  }
  return result;
};

export const isIndexInsideCollapsedSessionBreak = (items, index, expandedItems) => {
  const item = items[index];
  if (!item) return false;

  for (let i = index - 1; i >= 0; i -= 1) {
    if (items[i].type === 'session_break') {
      return !expandedItems[items[i].assignedId];
    }
  }
  return false;
};

export const getIndexAfterSessionBreakGroup = (items, index) => {
  let sbIndex = -1;
  for (let i = index - 1; i >= 0; i -= 1) {
    if (items[i].type === 'session_break') {
      sbIndex = i;
      break;
    }
  }
  if (sbIndex === -1) return index;

  let insertIndex = sbIndex + 1;
  for (let i = sbIndex + 1; i < items.length; i += 1) {
    if (items[i].type === 'session_break') break;
    insertIndex = i + 1;
  }
  return insertIndex;
};

export const wasUnderCollapsedSessionBreak = (item, expandedItemsMap, items) => {
  const itemIndex = items.findIndex((i) => i.assignedId === item.assignedId);
  if (itemIndex === -1) return false;

  const previousItems = items.slice(0, itemIndex);
  const lastSessionBreak = [...previousItems]
    .reverse()
    .find((i) => i.type === 'session_break');
  return lastSessionBreak ? !expandedItemsMap[lastSessionBreak.assignedId] : false;
};
